import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';


@Injectable()
export class MapService {

    constructor(private http: HttpClient) { }

    public fetchStreetGeoJson(id: number): Observable<any> {
        const url = `${environment.API_ENDPOINT}/gis/getStreetGeoJSON/${id}`;
        return this.http.get(url, {});
    }
}